export default class ClientConstants 
{
    public static  IDENTITY = "https://api-dev.flyx2.cloud/identity";
    public static  CLIENT_PRIMARY_COLOR = "#ED1C24";
    public static  CLIENT_NAME = "Renmans";
    public static  CLIENT_IMAGE = "https://www.renmans.be/themes/custom/renmans_main/images/logo-renmans-fr.png";
    public static ROUND_CLIENT_IMAGE = true;
}